// We only need to import the modules necessary for initial render
import PageLayout from '../layouts/PageLayout/PageLayout'
import Home from './Home'
import News from './News'
import NewsItem from './NewsItem'
import Careers from './Careers'
import Contact from './Contact'
import Service from './Service'
import PageDefault from './PageDefault'

/*  Note: Instead of using JSX, we recommend using react-router
    PlainRoute objects to build route definitions.   */

export const createRoutes = (store) => ({
  path        : '/',
  component  : PageLayout,
  indexRoute  : { component: Home },
  childRoutes : [
    {
      path: 'news/category/:slug',
      component: News
    },
    {
      path: 'news/:slug',
      component: NewsItem
    },
    {
      path: 'news',
      component: News
    },
    {
      path: 'services/:slug',
      component: Service
    },
    {
      path: 'services',
      onEnter: (_, replaceState) => {
        if (_.location.pathname === '/services/') {
          replaceState('/')
        }
      }
    },
    {
      path: 'careers',
      component: Careers
    },
    {
      path: 'contact',
      component: Contact
    },
    {
      path: ':slug',
      component: PageDefault
    }
  ]
})

/*  Note: childRoutes can be chunked or otherwise loaded programmatically
    using getChildRoutes with the following signature:

    getChildRoutes (location, cb) {
      require.ensure([], (require) => {
        cb(null, [
          // Remove imports!
          require('./Counter').default(store)
        ])
      })
    }

    However, this is not necessary for code-splitting! It simply provides
    an API for async route definitions. Your code splitting should occur
    inside the route `getComponent` function, since it is only invoked
    when the route exists and matches.
*/

export default createRoutes



// WEBPACK FOOTER //
// ./src/routes/index.js